module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master-consumable-item-detail"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master_stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master_consumable_item_list"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Consumable Item List')))])], 1), _vm._m(0)]), _c('h1', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("消耗品マスタ詳細")]), (_vm.isShow) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(1), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.consumableItem.name))])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(2), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.consumableItem.name_hurigana))])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(3), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.consumableItem.product_code))])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(4), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.consumableItem.category_name))])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(5), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.consumableItem.supplier_name))])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(6), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.consumableItem.unit))])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(7), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.consumableItem.size))])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(8), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.consumableItem.lot_number) + "/1ロット")])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(9), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.consumableItem.lot_price.toLocaleString()) + "円")])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(10), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderReception()))])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(11), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.content(_vm.consumableItem.remark))
    }
  })])])])]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default text-center"
  }, [(_vm.consumableItem.image_path) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('img', {
    staticClass: "img-responsive img-rounded pull-right",
    attrs: {
      "src": _vm.imagePath
    }
  })]) : _vm._e()])])])]) : _vm._e(), _c('div', {
    staticClass: "row margin-top margin-bottom"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.onClickCancel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v("消耗品詳細")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("消耗品名")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("消耗品名ふりがな")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("型番")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("カテゴリー")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("サプライヤー")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("単位")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("サイズ規格")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("1ロットあたりの数量")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("1ロットあたりの単価")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("発注受付")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("備考")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fe3d5142!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/master-consumable-item-detail.pug
// module id = 904
// module chunks = 1